import { motion } from "framer-motion";
import { Eyebrow, PrimaryButton, GhostButton } from "@/components/ui-bits";

const Hero = () => {
  return (
    <section data-testid="hero-section" aria-labelledby="hero-heading" className="relative overflow-hidden bg-white">
      <div className="grid lg:min-h-[640px] lg:grid-cols-12">
        <div className="container-30 flex items-center py-16 sm:py-20 lg:col-span-6 lg:py-24 lg:pr-0">
          <div className="max-w-xl">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
            >
              <Eyebrow>Asset-Based Transportation & 3PL</Eyebrow>
            </motion.div>
            <motion.h1
              id="hero-heading"
              data-testid="hero-headline"
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.1, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 text-4xl font-black leading-[1.02] tracking-tight text-[#191c1e] sm:text-5xl lg:text-6xl"
            >
              MOVING FREIGHT FORWARD.
            </motion.h1>
            <motion.p
              data-testid="hero-subcopy"
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
              className="mt-6 text-base leading-relaxed text-[#5f666d] sm:text-lg"
            >
              30 NORTH provides transportation solutions designed around your freight, schedule and delivery
              requirements, with additional transportation capacity available when your shipment requires it.
            </motion.p>
            <motion.div
              initial={{ opacity: 0, y: 28 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
              className="mt-10 flex flex-col gap-3 sm:flex-row sm:items-center"
            >
              <PrimaryButton to="/request-a-quote" testid="hero-primary-cta" className="w-full sm:w-auto">
                REQUEST A QUOTE
              </PrimaryButton>
              <GhostButton to="/services" testid="hero-secondary-cta" className="w-full sm:w-auto">
                EXPLORE SERVICES
              </GhostButton>
            </motion.div>
          </div>
        </div>
        <div className="relative h-72 sm:h-96 lg:col-span-6 lg:h-auto">
          <motion.img
            src="/assets/hero-truck.webp"
            alt="A modern white 30 NORTH tractor-trailer travelling on a clean Ontario highway near the Toronto skyline"
            data-testid="hero-image"
            initial={{ opacity: 0, scale: 1.04 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 1.1, ease: [0.22, 1, 0.36, 1] }}
            className="absolute inset-0 h-full w-full object-cover"
          />
          <div className="absolute inset-y-0 left-0 hidden w-24 bg-gradient-to-r from-white to-transparent lg:block" aria-hidden="true" />
          <div
            className="absolute bottom-5 left-5 max-w-[calc(100%-2.5rem)] bg-[#191c1e] px-4 py-2 text-[10px] font-bold leading-relaxed tracking-[0.14em] text-white sm:bottom-6 sm:left-6 sm:text-[11px] sm:tracking-[0.16em]"
            data-testid="hero-equipment-caption"
          >
            53' TRACTOR-TRAILER <span className="ml-2 text-[#ff6a00]">FTL & PARTIAL LOADS</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
